export default __webpack_public_path__ + "assets/9a8fb35787cf4789409b406dae17a441.jpeg";